import * as React from 'react';

type Props = {
  message: string;
};

const Error = (props: Props) => <div className="error">{props.message}</div>;

export default Error;
